import { render, staticRenderFns } from "./BookingTablePane.vue?vue&type=template&id=99cf2580&scoped=true"
import script from "./BookingTablePane.vue?vue&type=script&lang=js"
export * from "./BookingTablePane.vue?vue&type=script&lang=js"
import style0 from "./BookingTablePane.vue?vue&type=style&index=0&id=99cf2580&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99cf2580",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99cf2580')) {
      api.createRecord('99cf2580', component.options)
    } else {
      api.reload('99cf2580', component.options)
    }
    module.hot.accept("./BookingTablePane.vue?vue&type=template&id=99cf2580&scoped=true", function () {
      api.rerender('99cf2580', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods_activity/booking/BookingTablePane.vue"
export default component.exports